module.exports = __webpack_public_path__ + "static/img/son2.363f3cc3.png";